import React from "react";
import { FaExclamationTriangle } from "react-icons/fa";
import { Modal } from "../shared";

export default function WarningModal({ onClose }) {
  return (
    <Modal open onClose={onClose} maxWidth="sm">
      <Modal.Header title="Eksik Bilgi" onClose={onClose} />
      <Modal.Body>
        <div className="flex items-start gap-3">
          <div className="p-2 bg-amber-50 border border-amber-100 rounded-xl shrink-0">
            <FaExclamationTriangle className="w-4 h-4 text-amber-500" />
          </div>
          <p className="text-sm text-gray-600">
            Lütfen tüm ürünler için aylık tüketim adetini ve makine adetini
            giriniz.
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer className="flex justify-end">
        <button
          type="button"
          onClick={onClose}
          className="px-5 py-2.5 text-sm font-semibold text-white bg-gradient-to-r from-indigo-600 to-purple-600 rounded-xl shadow-sm hover:shadow-md hover:from-indigo-700 hover:to-purple-700 transition-all duration-200"
        >
          Tamam
        </button>
      </Modal.Footer>
    </Modal>
  );
}
